import { render, staticRenderFns } from "./restriction-tab-partial.vue?vue&type=template&id=09bae4e6"
import script from "./restriction-tab-partial.vue?vue&type=script&lang=js"
export * from "./restriction-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports